module.exports = __webpack_public_path__ + "img/PCB_KeyPad.527bcf15.jpg";